module.exports = __webpack_public_path__ + "static/media/curtis.b7813351.jpg";